import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Flex/flex';
import { formatBreakpointMods } from '../../helpers/util';
export var FlexItem = function FlexItem(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      spacer = _a.spacer,
      grow = _a.grow,
      shrink = _a.shrink,
      flex = _a.flex,
      alignSelf = _a.alignSelf,
      align = _a.align,
      fullWidth = _a.fullWidth,
      props = __rest(_a, ["children", "className", "spacer", "grow", "shrink", "flex", "alignSelf", "align", "fullWidth"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(formatBreakpointMods(spacer, styles), formatBreakpointMods(grow, styles), formatBreakpointMods(shrink, styles), formatBreakpointMods(flex, styles), formatBreakpointMods(alignSelf, styles), formatBreakpointMods(align, styles), formatBreakpointMods(fullWidth, styles), className)
  }), children);
};